import React, { useRef } from "react";
import "./CareerBooster.css";
import { Container, Row, Col } from "react-bootstrap";
import CareerBoosterContent from "./CareerBoosterContent/CareerBoosterContent";
import CareerBoosterPricing from "./CareerBoosterPricing/CareerBoosterPricing";
import Home_Partners from "../CommonPage/Home/home_Partners/Home_Partners";
import FaqSection from "../Career_Solutions/FaqSection/FaqSection";
import Contactus from "../CommonPage/Contact/Contactus";
import ScamAlertBanner from "../common_components/scamAlertBanner/ScamAlertBanner";
import CareerBoosterBenefits from "./CareerBoosterBenefits/CareerBoosterBenefits";
import CoverLetterPromo from "./CoverLetterPromo/CoverLetterPromo";
import BenefitsTable from "./BenefitsTable/BenefitsTable";
import CareerBoosterSteps from "./CareerBoosterSteps/CareerBoosterSteps";
import FrequentlyBought from "./FrequentlyBought/FrequentlyBought";
import BreadcrumbNav from "../common_components/breadcrumbNav/BreadcrumbNav";

function CareerBooster() {
  const benefitsTableRef = useRef(null);

const scrollToBenefitsTable = () => {
  benefitsTableRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
  
  // Define navigation layout items array dynamically
  const breadcrumbPaths = [
    { label: "Home", url: "/" },
    { label: "Services", url: "/career-services" },
    { label: "Career Booster" },
  ];
  return (
    <div className=" CareerBooster">
      <Container>
        <BreadcrumbNav items={breadcrumbPaths} />
        <Row className="g-4 align-items-start">
          {/* Scrollable Left Side Area */}
          <Col lg={8} className="scrollable_holder">
            <CareerBoosterContent />

            <Home_Partners />

            <CareerBoosterBenefits />

            <CoverLetterPromo />

        <div ref={benefitsTableRef}>
  <BenefitsTable />
</div>

            <CareerBoosterSteps />

            <FaqSection />

            <FrequentlyBought />

            <Contactus />
          </Col>

          {/* Sticky Right Side Context Frame */}
          <Col lg={4} className="CareerBoosterPricing_scrollable">
           <CareerBoosterPricing
  scrollToBenefitsTable={scrollToBenefitsTable}
/>
          </Col>
        </Row>

        <ScamAlertBanner />
      </Container>
    </div>
  );
}

export default CareerBooster;
